import React from 'react';
import PropTypes from 'prop-types';

import { Box } from '../../../design/css';
import OrderButton from './orderButton';
import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';
import {
  orderStatus as statusConstants,
  quoteStatus
} from '../../../utils/constant';

const OrderAction = ({
  order,
  button,
  orderStatus,
  status,
  onStatusChange,
  isOrderValidating,
  isValidated,
  actionChanged,
  channelName
}) => {
  const localizedString = useLocalizedStringsContext();

  const isTQChannel = channelName === 'TQ';

  const {
    ORDERS: { orderAction, save, sendContract, defaultOption, submitTheOrder },
    productInOrderForOptions: { esChat },
    contentfulValues: { no }
  } = localizedString;
  const { contractSent, orderSubmitted } = statusConstants;

  const { productInOrderFor, msaEContractBA } = order;

  const isSendContractAllowedWithTQ =
    [quoteStatus.approved].includes(orderStatus) &&
    (productInOrderFor === esChat ? msaEContractBA === no : isTQChannel);

  const isSendContractAllowed = [statusConstants.contractSent].includes(
    orderStatus
  );

  const isSubmitOrderWithTQ = [statusConstants.contractSigned].includes(
    orderStatus
  );

  const isStatusContactSent = orderStatus === statusConstants.contractSent;

  const getButtonLabel = () => {
    if (actionChanged) {
      switch (status) {
        case contractSent:
          return sendContract;
        case orderSubmitted:
          return submitTheOrder;
        default:
          return save;
      }
    }
    return save;
  };

  return (
    <>
      <div
        className="frg-select-container color-light"
        style={{
          position: 'relative',
          width: '100%',
          height: '50px',
          marginTop: '1.5rem'
        }}
      >
        <select style={{ fontSize: '1rem' }} onChange={onStatusChange}>
          <option selected disabled>
            {defaultOption}
          </option>
          {(isSendContractAllowedWithTQ || isSendContractAllowed) && (
            <option value={contractSent}>{orderAction.sendContract}</option>
          )}
          {(isSubmitOrderWithTQ || !isSendContractAllowedWithTQ) &&
            !isStatusContactSent && (
              <option value={orderSubmitted}>
                {orderAction.submitTheOrder}
              </option>
            )}
        </select>
      </div>

      {(isSendContractAllowedWithTQ ||
        isSendContractAllowed ||
        isSubmitOrderWithTQ ||
        !isSendContractAllowedWithTQ) && (
        <Box
          display="flex"
          justifyContent="space-evenly"
          flexDirection="row"
          width={100}
          mdWidth={100}
          right={3}
          left={3}
          top={5}
          bottom={4}
        >
          <OrderButton
            button={{ ...button, label: getButtonLabel() }}
            isOrderValidating={isOrderValidating}
            isValidated={isValidated}
            actionChanged={actionChanged}
          />
        </Box>
      )}
    </>
  );
};

OrderAction.propTypes = {
  button: PropTypes.shape({
    label: PropTypes.string,
    onClick: PropTypes.func,
    variant: PropTypes.string,
    isVisibleOnValidate: PropTypes.bool
  }).isRequired,
  orderStatus: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  onStatusChange: PropTypes.func.isRequired,
  isOrderValidating: PropTypes.bool.isRequired,
  isValidated: PropTypes.bool.isRequired,
  actionChanged: PropTypes.bool.isRequired,
  channelName: PropTypes.string.isRequired
};

export default OrderAction;
